module.exports = "<div style=\"width:100%;\">\r\n\t<canvas id=\"myChart\" height=\"450\" #mychart></canvas>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/thermometer/thermometer.component.html
// module id = ../../../../../src/app/content-page/thermometer/thermometer.component.html
// module chunks = main